import Vue from 'vue';
export const CartSelect = Vue.extend({
    functional: true,
    name: 'CartSelect',
    props: {
        shoppingCarts: Array,
        selectedCartId: Number,
    },
    render(createElement, ctx) {
        return (<select class="shopping-cart-menu__select" onChange={ctx.listeners.change}>
                {ctx.props.shoppingCarts.map((cart) => (<option value={cart.id} selected={ctx.props.selectedCartId === cart.id}>
                        {cart.cartName}
                    </option>))}
            </select>);
    },
});
//# sourceMappingURL=CartSelect.jsx.map